<!--
 * @Author: zhaoyang
 * @Date: 2020-10-27 10:42:36
 * @LastEditors: your name
 * @LastEditTime: 2020-10-29 16:45:48
 * @Description: 取消订单
-->
<template>
  <div class="explain-popup">
    <dl class="explain-context">
      <dt>退款時間：</dt>
      <dd>
        陪玩師同意後，退款金額將立即返回您的帳戶；若陪玩師未處理，則在24小時倒計時結束後自動退款回您的帳戶。
      </dd>
      <dt>退款金額：</dt>
      <dd>所有退款訂單不計算『滿贈』部分，只能退實際下單單數。</dd>
      <dd>
        若訂單使用『優惠券』或『首單優惠』，則在全部訂單退款時，退還優惠券;
      </dd>
      <dd>局部退款時，不退還優惠券。</dd>
      <dt>退款糾紛：</dt>
      <dd>若陪玩師拒絕退款，可在申請客服介入處理</dd>
      <dt>退款後的訂單狀態：</dt>
      <dd>退款後訂單不可再進行其他操作，不可評論。</dd>
    </dl>
    <div class="refound-footer">
      <div class="refound-submit" @click="handleOrderRound">返回申請退款</div>
    </div>
  </div>
</template>

<script>
import popupMixin from '@/components/common/popup/general.js';
export default {
  mixins: [popupMixin],
  methods: {
    handleOrderRound() {
      this.$emit('handleRoundExplain', 'orderRound');
    },
  },
};
</script>

<style lang="scss" scoped>
.explain-popup {
  max-height: 550px;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
  padding: 0 20px;
}
.close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-weight: 900;
  background: rgba(249, 249, 249, 0.78);
  color: rgba(0, 0, 0, 0.3);
}
.explain-context {
  margin-top: 5px;
  font-size: 14px;
  line-height: 20px;
  color: #222c43;
  padding-bottom: 72px;
  dt {
    margin-bottom: 8px;
    font-weight: 600;
  }
  dd {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 16px;
    &::before {
      content: '•';
      display: block;
      min-width: 15px;
    }
  }
}
.refound-footer {
  width: 375px;
  bottom: 0;
  left: 0;
  padding: 0 16px 30px;
  position: absolute;
}
.refound-submit {
  cursor: pointer;
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  border-radius: 25px;
  @include button-yellow;
  font-weight: 400;
}
</style>
